import { SET_USER_SECURITY_STATUS, CLEAR_USER_SECURITY_STATUS, } from '../actions/utilityActions';

const initState = {
secured: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_USER_SECURITY_STATUS:
      return { ...state, secured: action.data };

    case CLEAR_USER_SECURITY_STATUS:
      return { ...state, secured: null };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/utilityReducer.js